import { HYDRATE } from "next-redux-wrapper";
import { ActionsTopMembers } from "./actions";

const initialState = {
	data: [],
	meta: {},
	is_loading: true,
	error: null,
	status: "fetch_init",
	message: "",
};

function storeTopMembers(state = initialState, action) {

	switch (action.type) {

	case HYDRATE:
		return { ...state, ...action.payload.storeTopMembers };
	case ActionsTopMembers.LOAD_GET_TOP_MEMBERS:
		return {
			...state,
			status: "fetch_loading",
			is_loading: true,
			error: null,
		};

	case ActionsTopMembers.RES_GET_TOP_MEMBERS:
		return {
			...state,
			data: action.data.data || [],
			meta: action.data.meta,
			status: "fetch_result",
			is_loading: false,
			error: null,
		};
	case ActionsTopMembers.ERR_GET_TOP_MEMBERS:
		return {
			...state,
			data: [],
			meta: {},
			status: "fetch_error",
			message: "Error...",
			is_loading: false,
			error: true,
		};
	default:
		return { ...state };

	}

}

export default storeTopMembers;
